import type { Cell } from "@highmarch/domain";

/**
 * How many road tiles a tower at `spot` with `range` (cells) would cover (QoL P5): the road cells whose centre lies
 * within the range of the spot's centre — the same centre-to-centre measure the placement ring draws. Advice for the
 * placement hint; the sim's targeting (towers.ts) decides what is really shot.
 */
export function coveredRoadTiles(road: readonly Cell[], spot: Cell, range: number, minRange = 0): number {
  const r2 = range * range, m2 = minRange * minRange;
  let n = 0;
  for (const c of road) {
    const dx = c.x - spot.x, dy = c.y - spot.y, d2 = dx * dx + dy * dy;
    // the Mortar cannot shoot inside its blind ring (TOWERS_V2 minRange): those tiles are not covered
    if (d2 <= r2 && !(minRange > 0 && d2 < m2)) n++;
  }
  return n;
}
